<template>
    <div id="book">
        <section class="section">
            <div class="container">
                <h2 class="section-title" v-scroll-reveal>
                    <span class="_order">07</span>
                    <span class="_title" v-html="$t('Booking')"></span>
                </h2>

                <div class="flex flex-wrap md:items-center">
                    <div class="w-full md:w-1/2 mb-lg md:mb-0">
                        <h3 class="section-subtitle mb-base" v-scroll-reveal v-html="$t('index.booking.title')"></h3>
                    </div>

                    <div class="w-full md:w-1/2 xl:w-2/5 xl:ml-auto" v-scroll-reveal>
                        <p v-html="$t('Prices listed for 2024 season.')"></p>
                        <p class="mt-1" v-html="$t('Maximum stay 9 persons (group of young people not permitted).')"></p>
                        <p class="mt-1" v-html="$t('Pets are not allowed.')"></p>
                    </div>
                </div>

                <div class="flex flex-col md:flex-row md:flex-wrap mt-gap text-center">
                    <div class="flex flex-col md:flex-1" v-scroll-reveal>
                        <span class="bg-primary text-secondary text-display text-h5 xl:text-h4 p-2" v-html="$t('Season E')"></span>
                        <div class="flex flex-col text-sm fhd:text-base my-base">
                            <span class="my-2">02.01 - 10.05</span>
                            <span>07.09 - 17.12</span>
                        </div>
                        <span class="bg-secondary text-primary text-h5 xl:text-h4 text-bold p-2">1.596,00 &euro;</span>
                    </div>

                    <div class="flex flex-col md:flex-1" v-scroll-reveal>
                        <span class="bg-primary text-white text-display text-h5 xl:text-h4 p-2" v-html="$t('Season D')"></span>
                        <div class="flex flex-col text-sm fhd:text-base my-base">
                            <span class="my-2">11.05 - 31.05</span>
                            <span>31.08 - 06.09</span>
                        </div>
                        <span class="bg-secondary text-white text-h5 xl:text-h4 text-bold p-2">1.897,00 &euro;</span>
                    </div>

                    <div class="flex flex-col md:flex-1" v-scroll-reveal>
                        <span class="bg-primary text-secondary text-display text-h5 xl:text-h4 p-2" v-html="$t('Season C')"></span>
                        <div class="flex flex-col text-sm fhd:text-base my-base">
                            <span class="my-2">01.06 - 28.06</span>
                            <span>24.08 - 30.08</span>
                        </div>
                        <span class="bg-secondary text-primary text-h5 xl:text-h4 text-bold p-2">2.296,00 &euro;</span>
                    </div>

                    <div class="flex flex-col md:flex-1" v-scroll-reveal>
                        <span class="bg-primary text-white text-display text-h5 xl:text-h4 p-2" v-html="$t('Season B')"></span>
                        <div class="flex flex-col text-sm fhd:text-base my-base">
                            <span class="my-2">29.06 - 05.07</span>
                            <span>17.08 - 23.08</span>
                        </div>
                        <span class="bg-secondary text-white text-h5 xl:text-h4 text-bold p-2">2.996,00 &euro;</span>
                    </div>

                    <div class="flex flex-col md:flex-1" v-scroll-reveal>
                        <span class="bg-primary text-secondary text-display text-h5 xl:text-h4 p-2" v-html="$t('Season A')"></span>
                        <div class="flex flex-col text-sm fhd:text-base my-base">
                            <span class="my-2">06.07 - 16.08</span>
                        </div>
                        <span class="bg-secondary text-primary text-h5 xl:text-h4 text-bold p-2 md:mt-auto">3.493,00 &euro;</span>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-gray-lightest">
            <div class="container flex flex-col items-center">
                <h4 class="reveal">{{ $t('Available dates') }}</h4>

                <calendar :markedDates="$root.Config.googleCalendar" class="w-full mt-lg" v-scroll-reveal></calendar>
                <div class="flex items-center mt-lg text-xs" v-scroll-reveal>
                    <div class="flex items-center mr-base">
                        <span class="block w-1 h-1 bg-gray-light mr-1"></span>
                        {{ $t('Available') }}
                    </div>
                    <div class="flex items-center">
                        <span class="block w-1 h-1 bg-danger mr-1"></span>
                        {{ $t('Not available') }}
                    </div>
                </div>

                <router-link :to="{ name: 'booking', params: { locale: $i18n.locale() } }" class="btn mt-gap xl:mt-gap-lg" v-scroll-reveal exact v-html="$t('btn.book')"></router-link>
            </div>
        </section>
    </div>
</template>

<script>
export default {}
</script>
